import { transition, style, animate } from '@angular/animations';

const FADEOUT_DURATION = 400;
export const FADEOUT_ANIMATION = [
  transition(':leave', [style({ opacity: 1 }), animate(FADEOUT_DURATION, style({ opacity: 0 }))])
];
